import React, { FC, ReactNode } from 'react'
import { Container } from '../Container'
import { FullWidth } from '.'

interface ConstrainedFullWidthProps {
  children: ReactNode
}

/**
 * Full width of the screen, up to maximum width
 *
 * @param children the content to render at full width.
 * @constructor
 */
const ConstrainedFullWidth: FC<ConstrainedFullWidthProps> = ({ children }) => (
  <>
    <FullWidth>
      <Container>{children}</Container>
    </FullWidth>
  </>
)

export { ConstrainedFullWidth }
